export const restApiUrl = {
  //   dev: 'https://upitnik-1-e2241832.deta.app',
  prod: "https://upitnik-1-e2241832.deta.app",
};
